/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getServiceArticleTreatment } from '../fn/service-article-treatment/get-service-article-treatment';
import { GetServiceArticleTreatment$Params } from '../fn/service-article-treatment/get-service-article-treatment';
import { ServiceArticleTreatment } from '../models/service-article-treatment';

@Injectable({ providedIn: 'root' })
export class ServiceArticleTreatmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getServiceArticleTreatment()` */
  static readonly GetServiceArticleTreatmentPath = '/api/service-article-treatment';

  /**
   * Select standard treatments, services and sales articles for medical history
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getServiceArticleTreatment()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceArticleTreatment$Response(params?: GetServiceArticleTreatment$Params, context?: HttpContext): Observable<StrictHttpResponse<ServiceArticleTreatment>> {
    return getServiceArticleTreatment(this.http, this.rootUrl, params, context);
  }

  /**
   * Select standard treatments, services and sales articles for medical history
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getServiceArticleTreatment$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getServiceArticleTreatment(params?: GetServiceArticleTreatment$Params, context?: HttpContext): Observable<ServiceArticleTreatment> {
    return this.getServiceArticleTreatment$Response(params, context).pipe(
      map((r: StrictHttpResponse<ServiceArticleTreatment>): ServiceArticleTreatment => r.body)
    );
  }

}
